import React from 'react';
import { triggerPopup } from '../../lib/triggerPopup';

interface Props extends React.HTMLProps<HTMLAnchorElement> {
  href: string;
  children: React.ReactNode;
}

export const PopupLink: React.FC<Props> = ({ href, children, ...rest }) => {
  return (
    <a href={href} onClick={triggerPopup} {...rest}>
      {children}
    </a>
  );
};
